import { render, staticRenderFns } from "./OrganizationLogo.vue?vue&type=template&id=4b1715f2"
import script from "./OrganizationLogo.vue?vue&type=script&lang=ts"
export * from "./OrganizationLogo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports